import { Textarea } from "@/components/ui/textarea";
import { HelpCircle } from "lucide-react";
import { VoiceButton } from "@/components/workflow/common/VoiceButton";

interface DescriptionFormProps {
  value: string;
  onChange: (value: string) => void;
  isLocked?: boolean;
}

export function DescriptionForm({ value, onChange, isLocked }: DescriptionFormProps) {
  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-bold text-slate-700">{"What does your business do? Describe your main activities, products or services, and the customers you serve"}<span className="text-red-500">*</span></h3>
          <HelpCircle className="h-4 w-4 text-slate-600" />
        </div>
        <VoiceButton
          onTranscript={onChange}
          disabled={isLocked}
          variant="ghost"
          className="h-7 rounded-2xl px-0 text-xs font-semibold text-slate-500 shadow-none hover:text-[#00444C]"
          recordingClassName="text-destructive hover:text-destructive"
          iconClassName="h-3.5 w-3.5 text-[#00444C]"
          recordingIconClassName="animate-pulse text-destructive"
          data-testid="button-voice-input"
        />
      </div>
      <Textarea
        placeholder={"Describe your main business activities, products, services, and market segments..."}
        className="min-h-[180px] rounded-3xl border-0 bg-slate-50 px-4 pt-3 text-sm text-slate-900 outline outline-1 outline-offset-[-1px] outline-slate-200 placeholder:text-slate-400 focus-visible:ring-0"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid="textarea-activities"
        disabled={isLocked}
      />
      <p className="text-xs text-muted-foreground">{"You can speak your description and it will be transcribed automatically"}</p>
    </div>
  );
}
